import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Offcanvas, Modal, Navbar, Nav, Button } from "react-bootstrap";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { ImCross } from "react-icons/im";
import { logoutUser } from "../redux/auth/actions";
import StaticLogo from "../assets/images/staticlogo.png";
import numberWithCommas from "../utils/numbersWithComma";
import { getUserBet } from "../redux/sports/actions";
import Casino1 from "../assets/images/games-icon/casinoezugi-icon.webp";
import Evolution from "../assets/images/games-icon/Ezugi.webp";
import Exchange from "../assets/images/games-icon/Exchange.png";
import SportsbookIcon from "../assets/images/games-icon/Sportsbook.png";
import Slots1 from "../assets/images/games-icon/slot-machine.png";
import supern from "../assets/images/games-icon/Supernova1.webp";
import xpg from "../assets/images/games-icon/xpg1.webp";
import kingmaker from "../assets/images/games-icon/Kingmaker.png";
import Pragmaticplay from "../assets/images/games-icon/casinoezugi-icon.webp";
import Qtech from "../assets/images/games-icon/Qtech.webp";
import AltGame from "../assets/images/games-icon/ALTGaming.png";
import AuraGame from "../assets/images/games-icon/Turbo-games.png";
import ProfileIcon from "../assets/svg/ProfileIcon";
import BetIcon from "../assets/svg/BetIcon";
import StatementIcon from "../assets/svg/StatementIcon";
import BonusImg from "../assets/images/bonus.png";
import refferal from "../assets/images/referral.png";
import LogoutIcon from "../assets/svg/LogoutIcon";
import WhatsappIcon1 from "../assets/images/icons/whatsap.png";
import WhatsappIcon from "../assets/images/social.png";
import TelegramIcon1 from "../assets/images/icons/instagram.png";
import GamesSearchModal from "../views/components/GamesSearchModal";
import LanguageChange from "../views/components/LanguageChange";
import Calling1 from "../assets/images/phone-call.png";

const HeaderAfterLogin = () => {
  const { user, wallet, exposureAmount } = useSelector((state) => state.auth);
  const { betMatches, userBets } = useSelector((state) => state.sports);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const [isLanguageShow, setIsLanguageShow] = useState(true);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showBetModal, setShowBetModal] = useState(false);
  const [showUserBetModal, setShowUserBetModal] = useState(false);
  const [showToggle, setShowToggle] = useState(true);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  useEffect(() => {
    if (showToggle) {
      document.body.classList.add("header_open");
    } else {
      document.body.classList.remove("header_open");
    }
  }, [showToggle]);

  useEffect(() => {
    setShowToggle(window.screen.width > 992);
    loadNotifications();
    return () => {};
  }, []);

  const handleRowClick = (item) => {
    dispatch(
      getUserBet({
        skip: 0,
        pageSize: 10,
        refmatchid: item?.refMatchId,
      })
    );
    setShowBetModal(false);
    setShowUserBetModal(true);
  };

  const [showLightModeToggle, setShowLightModeToggle] = useState(false);

  useEffect(() => {
    if (showLightModeToggle) {
      document.body.classList.add("light-mode");
    } else {
      document.body.classList.remove("light-mode");
    }
  }, [showLightModeToggle]);

  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);

  useEffect(() => {
    if (showLeftbarToggle) {
      document.body.classList.add("leftbat-opened");
    } else {
      document.body.classList.remove("leftbat-opened");
    }
  }, [showLeftbarToggle]);

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }}>{notf?.content}</label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header aftrlgn">
        <div className="top_head">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="logo">
                      <a href="/home">
                        <img src={appDetails?.LOGO_URL} alt="Logo" />
                      </a>
                    </div>
                  </div>

                  <div className="staticLogo">
                    <img src={StaticLogo} />
                  </div>

                  <Navbar expand="xl" className="d-none d-xl-block">
                    <Navbar.Toggle
                      aria-controls="basic-navbar-nav"
                      onClick={() => setShowToggle((s) => !s)}
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                      <Nav>
                        {/* <Nav.Link href="/home" className="logoImg d-xl-none">
                          <img src={appDetails?.LOGO_URL} alt="Logo" />
                        </Nav.Link>
                        <Nav.Link href="/casino/ezugi">
                          <img src={Casino1} alt="bottom head link icon" />
                          <span>Ezugi</span>
                        </Nav.Link>
                        <Nav.Link href="/casino/evolution">
                          <img src={Evolution} alt="bottom head link icon" />
                          <span>Evolution</span>
                        </Nav.Link> */}
                        <Nav.Link href="/exchange/Cricket">
                          <img src={Exchange} alt="Exchange Icon" width={20} />{" "}
                          <span>Exchange</span>
                        </Nav.Link>
                        {/* <Nav.Link href="/spmsports/live">
                          <img src={SportsbookIcon} alt="Sportsbook" />{" "}
                          <span>SPM Sports</span>
                        </Nav.Link> */}
                        <Nav.Link href="/sportsbook">
                          <img src={SportsbookIcon} alt="Sportsbook" />{" "}
                          <span>Atlas</span>
                        </Nav.Link>
                        <Nav.Link href="/Slots">
                          <img src={Slots1} alt="bottom head link icon" />
                          <span>Slots</span>
                        </Nav.Link>
                        {/* <Nav.Link href="/casino/supernowa">
                          <img src={supern} alt="bottom head link icon" />
                          <span>Supernowa</span>
                        </Nav.Link>
                        <Nav.Link href="/casino/xpg">
                          <img src={xpg} alt="bottom head link icon" />
                          <span>Xpg</span>
                        </Nav.Link> */}
                        <Nav.Link href="/kingmaker">
                          <img src={kingmaker} alt="bottom head link icon" />
                          <span>Kingmaker</span>
                        </Nav.Link>

                        {/* <Nav.Link href="/casino/qtech">
                          <img src={Qtech} alt="bottom head link icon" />
                          <span>Qtech</span>
                        </Nav.Link> */}
                        <Nav.Link href="/gap">
                          <img src={AltGame} alt="bottom head link icon" />
                          <span>ALT Gaming</span>
                        </Nav.Link>
                        <Nav.Link href="/vimplay">
                          <img src={AltGame} alt="bottom head link icon" />
                          <span>Vimplay Games</span>
                        </Nav.Link>
                        <Nav.Link href="/aura-games">
                          <img src={AuraGame} alt="bottom head link icon" />
                          <span>Aura Games</span>
                        </Nav.Link>
                      </Nav>
                    </Navbar.Collapse>
                  </Navbar>

                  <div className="headerRight">
                    {/* {!isApkEnv ? (
                      <a
                        href=""
                        download=""
                      >
                        <img
                          src={APK}
                          alt="Calling icon"
                          style={{ width: "30px", margin: "8px" }}
                        />
                      </a>
                    ) : null} */}
                    <a
                      href={`tel://${appDetails?.PHONE}`}
                      className="d-block d-md-none"
                    >
                      <img
                        src={Calling1}
                        alt="Calling icon"
                        style={{ width: "32px" }}
                      />
                    </a>
                    <a
                      className="panel social-icon watsapp d-block d-md-none"
                      href={
                        appDetails?.WHATS_APP_URL != ""
                          ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                          : "javascript:void(0)"
                      }
                      target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                    >
                      <img
                        src={WhatsappIcon}
                        alt="whatsappicon"
                        style={{ width: "32px", margin: "8px" }}
                      />
                    </a>
                    <GamesSearchModal />
                    <div className="LanguageCancelSection d-none d-md-block">
                      {/* <div className={isLanguageShow ? "" : "d-none"}>
                        <LanguageChange />
                      </div> */}
                      {isLanguageShow && (
                        <div
                          style={{ marginRight: "5px", cursor: "pointer" }}
                          onClick={() => setIsLanguageShow((prev) => !prev)}
                          className="LanguageCancel"
                        >
                          <ImCross />
                        </div>
                      )}
                    </div>
                    <Dropdown align="end" className="me-2">
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        Bal: <span>{numberWithCommas(wallet?.cash || 0)}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="tel:{user?.mobileno}">
                          <b>{user?.mobileno}</b>
                        </Dropdown.Item>
                        <Dropdown.Item href="javascript:void(0)">
                          <h6>Balance</h6>
                          <span>INR {numberWithCommas(wallet?.cash || 0)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="javascript:void(0)"
                          onClick={() => setShowBetModal(true)}
                        >
                          <h6>Exposure</h6>
                          <span>
                            INR {numberWithCommas(exposureAmount || 0)}
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item href="javascript:void(0)">
                          <h6>Bonus</h6>
                          <span>INR {numberWithCommas(wallet?.coins)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="/gatewaylist" className="deposit">
                          Deposit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <div className="funds me-2">
                      <ul>
                        <li className="d-none d-md-block">
                          <a href="/gatewaylist" className="deposit">
                            Deposit
                          </a>
                        </li>
                      </ul>
                    </div>
                    <Button variant="primary menu-btn" onClick={handleShow}>
                      <ProfileIcon />
                    </Button>
                  </div>
                </div>
                <Navbar className="d-block d-xl-none">
                  <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    onClick={() => setShowToggle((s) => !s)}
                  />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav>
                      {/* <Nav.Link href="/casino/ezugi">
                        <img src={Casino1} alt="bottom head link icon" />
                        <span>Ezugi</span>
                      </Nav.Link>
                      <Nav.Link href="/casino/evolution">
                        <img src={Evolution} alt="bottom head link icon" />
                        <span>Evolution</span>
                      </Nav.Link> */}
                      <Nav.Link href="/exchange/Cricket">
                        <img src={Exchange} alt="Exchange Icon" width={20} />{" "}
                        <span>Exchange</span>
                      </Nav.Link>
                      {/* <Nav.Link href="/spmsports/live">
                        <img src={SportsbookIcon} alt="Sportsbook" />{" "}
                        <span>SPM Sports</span>
                      </Nav.Link> */}

                      <Nav.Link href="/sportsbook">
                        <img src={SportsbookIcon} alt="Sportsbook" />{" "}
                        <span>Atlas</span>
                      </Nav.Link>
                      <Nav.Link href="/Slots">
                        <img src={Slots1} alt="bottom head link icon" />
                        <span>Slots</span>
                      </Nav.Link>
                      {/* <Nav.Link href="/casino/supernowa">
                        <img src={supern} alt="bottom head link icon" />
                        <span>Supernowa</span>
                      </Nav.Link>
                      <Nav.Link href="/casino/xpg">
                        <img src={xpg} alt="bottom head link icon" />
                        <span>Xpg</span>
                      </Nav.Link> */}
                      <Nav.Link href="/kingmaker">
                        <img src={kingmaker} alt="bottom head link icon" />
                        <span>Kingmaker</span>
                      </Nav.Link>
                      {/* <Nav.Link href="/casino/qtech">
                        <img src={Qtech} alt="bottom head link icon" />
                        <span>Qtech</span>
                      </Nav.Link> */}
                      <Nav.Link href="/gap">
                        <img src={AltGame} alt="bottom head link icon" />
                        <span>ALT Game</span>
                      </Nav.Link>
                      <Nav.Link href="/turbo-games" className="d-md-none">
                        <img src={AltGame} alt="bottom head link icon" />
                        <span>Turbo Games</span>
                      </Nav.Link>
                      <Nav.Link href="/aura-games">
                        <img src={AltGame} alt="bottom head link icon" />
                        <span>Aura Games</span>
                      </Nav.Link>
                      <Nav.Link href="/vimplay">
                        <img src={AltGame} alt="bottom head link icon" />
                        <span>Vimplay Games</span>
                      </Nav.Link>
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="bottom_head d-none">
          <Container fluid>
            <Row>
              <Col xs={12} className="px-0">
                <ul>
                  <li>
                    <a href="/casino/ezugi">
                      <img src={Casino1} alt="bottom head link icon" />
                      <span>Ezugi Games</span>
                    </a>
                  </li>

                  <li>
                    <a href="Slots">
                      <img src={Slots1} alt="bottom head link icon" />
                      <span>Slots</span>
                    </a>
                  </li>
                  <li>
                    <a href="/casino/evolution">
                      <img src={Evolution} alt="bottom head link icon" />
                      <span>Evolution</span>
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>

        <Offcanvas show={show} onHide={handleClose} placement={"end"}>
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <ProfileIcon />
                </div>
                <div className="user-info">
                  <span>{user?.mstruserid}</span>
                  <a>{user?.mobileno}</a>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row">
              <div className="col-6">
                <div className="balance mb-1">Main Balance</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-1">
                  {numberWithCommas(wallet?.cash || 0)}
                </div>
              </div>
              <div className="col-6">
                <div className="balance mb-3">Bonus</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-3">
                  {numberWithCommas(wallet?.coins) || 0}
                </div>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/withdraw");
                }}
              >
                <Button className="btn_primary" variant="   w-100">
                  Withdraw
                </Button>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/gatewaylist");
                }}
              >
                <Button className="btn_primary" variant="primary w-100">
                  Deposit
                </Button>
              </div>
            </div>
            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <ProfileIcon />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <BetIcon />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <StatementIcon />
                  <span>Account Statement</span>
                </a>
              </li>
              <li>
                <a href="/bonus">
                  <img src={BonusImg} />
                  <span className="bonus-space">Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral">
                  <img src={refferal} />

                  <span className="bonus-space">Referral</span>
                </a>
              </li>

              <li onClick={() => dispatch(logoutUser(true))}>
                <a href="#">
                  <LogoutIcon />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            <ul className="social_links">
              <li>
                <a
                  className="panel social-icon watsapp"
                  href={
                    appDetails?.INSTATGRAM != ""
                      ? appDetails?.INSTATGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                >
                  <img src={TelegramIcon1} alt="whatsappicon" />
                </a>
              </li>

              <li>
                <a
                  className="panel social-icon watsapp"
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "javascript:void(0)"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <span className="notification-count">2</span>
                  <img src={WhatsappIcon1} alt="whatsappicon" />
                </a>
              </li>
            </ul>
          </Offcanvas.Body>
        </Offcanvas>

        <Modal
          className="betslip_popup outer_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Exposure amount</th>
                      <th scope="col">Match name</th>
                      <th scope="col">Ref match ID</th>
                      <th scope="col">Total bets</th>
                    </tr>
                  </thead>
                  <tbody>
                    {betMatches &&
                      betMatches.length &&
                      betMatches.map((item, index) => {
                        return (
                          <tr
                            onClick={() => {
                              handleRowClick(item);
                            }}
                          >
                            <th scope="row">{index + 1}</th>
                            <td>{item?.exposureAmount}</td>
                            <td>{item?.matchName}</td>
                            <td>{item?.refMatchId}</td>
                            <td>{item?.totalBets}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="betslip_popup inner_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUserBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Odds</th>
                      <th scope="col">Stack</th>
                      <th scope="col">Selection type</th>
                      <th scope="col">Status</th>
                      <th scope="col">Create date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userBets &&
                      userBets.length &&
                      userBets.map((item, index) => {
                        return (
                          <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.odds}</td>
                            <td>{item?.stack}</td>
                            <td>{item?.selectionType}</td>
                            <td>{item?.status}</td>
                            <td>{item?.createdAt}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowUserBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
